import { useApi } from '~/composables/common/use-api'
import { CMS_API } from '~/configs/api'
import { HttpRequestMethod } from '~/configs/enums'
import { useContactStore } from '~/stores/contact.store.ts'
import type { ContactItem } from '~/utils/interface'
import { ResponseStatus } from '~composables/common/interface'

export function useContact() {
  const { request } = useApi()
  const store = useContactStore()
  const contacts = computed((): ContactItem[] => {
    return [...store.contacts]?.map(item => {
      return {
        ...item,
        img: `/assets/images/icons/contact/${item.icon ?? ''}.svg`
      }
    })
  })
  const emailSupport = computed(() => {
    return store?.contacts?.find(item => item.label === 'Email')
  })
  const telegramSupport = computed(() => {
    return store?.contacts?.find(item => item.label === 'Telegram')
  })
  async function fetchContact(force: boolean = false): Promise<void> {
    if (!force && Object.entries(store.contacts).length > 0) {
      return
    }
    try {
      const { data, status } = await request(CMS_API.CONTACTS, {
        method: HttpRequestMethod.GET
      })

      if (status === ResponseStatus.OK) {
        const dataResponse = data as Record<string, ContactItem>
        if (dataResponse) {
          const listContact = Object.values(dataResponse).map(item => ({
            label: item?.label,
            title: item?.detail,
            link: item?.detailScheme,
            icon: `icon-${String(item.label?.toLowerCase())}`,
            newTab: !!item?.newTab,
            img: item?.img
          }))
          store.setContact(listContact)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  return {
    contacts,
    fetchContact,
    emailSupport,
    telegramSupport
  }
}
